'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reduxForm = require('redux-form');

var _CancelSubscriptionPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/CancelSubscriptionPopup');

var _CancelSubscriptionPopup2 = _interopRequireDefault(_CancelSubscriptionPopup);

var _ThanksPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/ThanksPopup');

var _ThanksPopup2 = _interopRequireDefault(_ThanksPopup);

var _ConfirmationOfCancelSubscriptionPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/ConfirmationOfCancelSubscriptionPopup');

var _ConfirmationOfCancelSubscriptionPopup2 = _interopRequireDefault(_ConfirmationOfCancelSubscriptionPopup);

var _FeedbackPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/FeedbackPopup');

var _FeedbackPopup2 = _interopRequireDefault(_FeedbackPopup);

var _AppSideEffects = require('../AppSideEffects/AppSideEffects');

var _AppSideEffects2 = _interopRequireDefault(_AppSideEffects);

var _subscriptions = require('redux/modules/subscriptions');

var subscriptionService = _interopRequireWildcard(_subscriptions);

var _zendesk = require('redux/modules/zendesk.js');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationOfCancelSubscription = (_dec = (0, _reduxForm.reduxForm)({
  form: 'cancelSubscriptionReason',
  fields: ['reason', 'otherInput']
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription,
    user: state.user

  };
}, (0, _extends3.default)({}, subscriptionService, { createTicket: _zendesk.createTicket })), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ConfirmationOfCancelSubscription, _React$Component);

  function ConfirmationOfCancelSubscription(props) {
    (0, _classCallCheck3.default)(this, ConfirmationOfCancelSubscription);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmationOfCancelSubscription.__proto__ || (0, _getPrototypeOf2.default)(ConfirmationOfCancelSubscription)).call(this, props));

    _this.state = {
      successful: false,
      cancelling: false,
      message: '',
      error: ''
    };

    _this.onCancelled = _this.onCancelled.bind(_this);
    _this.onAborted = _this.onAborted.bind(_this);

    _this.handleClick = _this.handleClick.bind(_this);
    _this.whatsNewPopup = _this.whatsNewPopup.bind(_this);
    _this._cancelSubscription = _this._cancelSubscription.bind(_this);
    _this.talkToUs = _this.talkToUs.bind(_this);
    _this.listAssets = _this.listAssets.bind(_this);
    _this.thankyouPopup = _this.thankyouPopup.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ConfirmationOfCancelSubscription, [{
    key: 'isCancelling',
    value: function isCancelling(_isCancelling) {
      this.setState({
        cancelling: _isCancelling
      });
    }
  }, {
    key: 'talkToUs',
    value: function talkToUs() {
      var _this2 = this;

      this.thankyouPopup();
      return this.props.createTicket({ name: this.props.user.name || 'Name is empty at backend', email: this.props.user.email, comment: 'I would like to learn more about how I can use my subscription for my project. ' + this.props.user.email, tag: 'cancelation', subject: 'Cancelation of Subscription' }).then(function () {
        _this2.isCancelling(false);
        //this.props.onCloseYes();
      }, function () {
        _this2.isCancelling(false);
        //this.props.onCloseYes();
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      //e.stopPropagation();
      // alert('Inside handleclick');

      var _props = this.props,
          _props$fields = _props.fields,
          radio = _props$fields.reason,
          otherInput = _props$fields.otherInput,
          submitting = _props.submitting,
          handleSubmit = _props.handleSubmit,
          childReference = _props.childReference;

      this.context.dialogs.custom(_react2.default.createElement(_FeedbackPopup2.default, {
        whatsNewPopup: this.whatsNewPopup,
        cancelSubscriptionOnClick: this._cancelSubscription
      }));
    }
  }, {
    key: 'thankyouPopup',
    value: function thankyouPopup() {

      this.context.dialogs.custom(_react2.default.createElement(
        _AppSideEffects2.default,
        null,
        _react2.default.createElement(_ThanksPopup2.default, {
          icon: "https://d3uwib8iif8w1p.cloudfront.net/megascans/home/quixel_2080_logo.png",
          closePopup: this.props.onCloseYes,
          title: 'Thanks!',
          description: 'We\'ve got your info, and will get back to you soon.',
          message: '<p>Thanks for reaching out.</p> <br /><p>Someone from our team will get in touch with you very soon.</p>'
        })
      ));
    }
  }, {
    key: 'whatsNewPopup',
    value: function whatsNewPopup() {
      var expiresAt = this.props.subscription.expiresAt;

      var expiryDate = (0, _moment2.default)(expiresAt).format('MMMM Do, YYYY');
      this.context.dialogs.custom(_react2.default.createElement(
        _AppSideEffects2.default,
        null,
        _react2.default.createElement(_ConfirmationOfCancelSubscriptionPopup2.default, {
          date: expiryDate,
          listAssets: this.listAssets,
          onCancelSubscriptionClick: this.onCancelled,
          onKeepSubscriptionClick: this.handleClick,
          talkToUs: this.talkToUs
        })
      ));
    }
  }, {
    key: '_cancelSubscription',
    value: function _cancelSubscription(value) {
      var _this3 = this;

      var expiresAt = this.props.subscription.expiresAt;

      var expiryDate = (0, _moment2.default)(expiresAt).format('MMMM Do, YYYY');
      this.context.dialogs.custom(_react2.default.createElement(
        _AppSideEffects2.default,
        null,
        _react2.default.createElement(_CancelSubscriptionPopup2.default, {
          icon: '/megascans_logo_small.png',
          date: expiryDate,
          closePopup: this.props.onCloseYes
        })
      ));
      if (value.length > 0) {
        this.isCancelling(true);
        this.props.cancelSubscription(typeof value === 'string' ? value : 'Cancel anyway').then(function () {
          _this3.isCancelling(false);
        }, function () {
          _this3.isCancelling(false);
        });
      }
    }
  }, {
    key: 'onCancelled',
    value: function onCancelled(reason) {
      var _this4 = this;

      this.isCancelling(true);
      this.props.cancelSubscription(typeof reason === 'string' ? reason : 'Cancel anyway').then(function () {
        _this4.isCancelling(false);
        _this4.props.onCloseYes();
      }, function () {
        _this4.isCancelling(false);
        _this4.props.onCloseYes();
      });
    }
  }, {
    key: 'onAborted',
    value: function onAborted() {
      this.props.onCloseYes();
    }
  }, {
    key: 'listAssets',
    value: function listAssets() {
      var randomProperty = function randomProperty(obj) {
        var keys = (0, _keys2.default)(obj);
        return obj[keys[keys.length * Math.random() << 0]];
      };
      var list = {
        set1: ['https://ddinktqu5prvc.cloudfront.net/asset-shfsaida/shfsaida_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-sconJ/Grid_render_thumb_retina_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-skpfegtc/skpfegtc_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-sgymdisf2/sgymdisf_Grid_720_thumb.jpg'],
        set2: ['https://ddinktqu5prvc.cloudfront.net/asset-sjziebea/sjziebea_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-rjske/Grid_render_thumb_retina_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-sg2lfbxc/sg2lfbxc_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-sg3nei0i2/sg3nei0i_Grid_720_thumb.jpg'],
        set3: ['https://ddinktqu5prvc.cloudfront.net/asset-sjfnch0a/sjfnch0a_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-rjrrH/GridRender_Thumb_Retina_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-shcqxhh/shcqxhh_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-sf3pag2i2/sf3pag2i_Grid_720_thumb.jpg'],
        set4: ['https://ddinktqu5prvc.cloudfront.net/asset-sjelciga/sjelciga_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-scout/Aset_castle_column_L_scout_Thumb_Highpoly_Retina_thumb_retina.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-sgfpf2g/sgfpf2g_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-sf1hahgf2/sf1hahgf_Grid_720_thumb.jpg'],
        set5: ['https://ddinktqu5prvc.cloudfront.net/asset-sjdhdjqa/sjdhdjqa_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-rijwE/GridRender_thumb_retina_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-sdutrnk/sdutrnk_Grid_720_thumb.jpg', 'https://ddinktqu5prvc.cloudfront.net/asset-shzlbd1f2/shzlbd1f_Grid_720_thumb.jpg']
      };
      return randomProperty(list);
    }
  }, {
    key: 'render',
    value: function render() {
      var expiresAt = this.props.subscription.expiresAt;

      var expiryDate = (0, _moment2.default)(expiresAt).format('MMMM Do, YYYY');

      return _react2.default.createElement(
        _AppSideEffects2.default,
        null,
        _react2.default.createElement(_ConfirmationOfCancelSubscriptionPopup2.default, {
          date: expiryDate,
          onCancelSubscriptionClick: this.onCancelled,
          onKeepSubscriptionClick: this.handleClick,
          talkToUs: this.talkToUs,
          cancelling: true,
          message: this.state.message,
          error: this.state.error,
          listAssets: this.listAssets
        })
      );
    }
  }]);
  return ConfirmationOfCancelSubscription;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ConfirmationOfCancelSubscription;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmationOfCancelSubscriptionPopup/ConfirmationOfCancelSubscription.js
// module id = 2427
// module chunks = 0